<template>
  <div class="mainBox" v-if="noticeData.length != 0"> 
      <!-- {{noticeData}} -->
    <ul v-for=" item in noticeData" :key="item.id" >
      <li class="list read clearfix" v-if="item.readInd == '1' " @click="readNotice(item)"><span class="cont">{{item.content | moreWorldFilter}}</span> <span class="dateTime">{{item.lastUpdateDt}}</span><i class="ide">未读</i></li>
      <li class="list unread clearfix" v-else @click="readNotice(item)"><span class="cont">{{item.content  | moreWorldFilter}}</span> <span class="dateTime">{{item.lastUpdateDt}}</span><i class="ide">已读</i></li>
    </ul>
    
    <div style="padding:20px 0" class="clearfix">
      <Page
        :total="pageTotal"
        show-total
        :current="currNum"
        @on-change="handlePage"
        :style="{ float: 'right', margin: '16px' }"
      />
    </div>

    <!-- 消息内容 -->
    <Modal v-model="noticeDetail" :footer-hide="true">
        <p class="noticeConM">{{noticeContent}}</p> 
    </Modal>

  </div>
  <div class="empty" v-else>
        <svg t="1618297954238" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2535" width="100" height="100"><path d="M459.485 887.553v-1.398 1.398z m55.893-60.475c-30.733 0-55.893 23.867-55.893 53.996v0.67c0 6.163 4.87 10.975 11.139 10.975 6.262 0 11.139-4.812 11.139-10.975v-0.67c0-17.808 14.618-32.82 33.516-32.82s33.516 15.012 33.516 32.82v0.67c0 6.163 4.87 10.975 11.14 10.975 6.262 0 11.139-4.812 11.139-10.975v-0.67c0.197-29.453-24.963-53.996-55.696-53.996zM381.766 710.664c-15.846-3.57-39.457-2.776-44.465 13.391-2.862 9.826 13.594 11.316 28.724 14.789 12.164 2.776 18.708 9.124 17.277 11.31-2.862 3.57-20.854-3.473-37.317 2.087-15.845 5.652-12.878 19.745-3.577 23.217 9.308 3.571 24.438-0.696 59.602 4.963 17.985 2.776 28.724-2.783 30.87-13.398 4.09-23.912-28.927-51.396-51.114-56.359z m209.394 56.49c2.146 10.424 12.163 16.03 30.87 13.28 35.164-5.606 50.294-1.379 59.596-4.923 9.3-3.44 12.163-18.19-3.578-23.007-15.845-5.606-33.74 1.378-37.31-2.068-2.146-2.757 5.008-9.045 17.27-11.9 15.032-3.545 31.586-4.917 28.724-14.652-5.008-16.036-28.008-16.718-44.464-13.279-22.384 4.923-55.5 32.164-51.108 56.55z m420.835-294.726l-195.28-181.004c-6.302-6.374-15.492-9.163-24.596-9.163H232.473a35.814 35.814 0 0 0-23.893 9.163L11.9 472.428C4.202 479.498 0 488.668 0 499.321v443.39C0 987.24 35.794 1024 80.79 1024h862.414c44.195 0 80.79-36.759 80.79-81.29V499.322c-0.098-9.958-5.002-19.823-11.999-26.893z m-351.965-2.54c-12.65 0-23.29 10.62-23.29 24.143 0 66.809-56.398 122.997-123.338 122.997S390.063 560.84 390.063 494.031c0-12.82-10.542-24.143-23.283-24.143H91.897l146.621-135.115H786.88l145.217 135.115H660.023z m311.452 48.679v425.962c0 15.576-11.92 26.958-26.749 26.958H80.666c-15.53 0-28.153-12.077-28.153-26.958V518.567h292.763c5.613 36.844 23.244 71.594 51.397 97.85 32.36 31.154 73.846 47.53 117.53 47.53 43.585 0 85.162-16.974 117.523-47.523 27.457-26.965 45.79-60.914 51.396-97.857h288.36z m-723.23-315.049l-89.835-83.941a23.447 23.447 0 0 1-0.807-33.477c9.176-9.432 24.398-9.82 33.982-0.788l89.73 83.942a23.447 23.447 0 0 1 0.913 33.476 24.313 24.313 0 0 1-33.982 0.788z m241.887-39.39a23.65 23.65 0 0 1-7.647-16.64l-3.315-122.913C478.868 11.303 489.614 0.406 503.155 0.012c13.64-0.295 24.904 10.103 25.318 23.277l3.216 122.912a23.808 23.808 0 0 1-14.572 22.383 25.239 25.239 0 0 1-26.978-4.457z m232.702 32.688a23.913 23.913 0 0 1-7.351-16.837 24.123 24.123 0 0 1 6.459-17.132l84.02-89.77a23.453 23.453 0 0 1 33.463-0.8 24.3 24.3 0 0 1 0.795 33.975l-84.02 89.77a24.011 24.011 0 0 1-16.575 7.47c-6.157 0-12.209-2.298-16.784-6.676z" fill="#E6E6E6" p-id="2536"></path></svg>
    <div>空空如也</div>
    </div>
</template>
<script>
export default {
    filters:{
        moreWorldFilter(value){
       if (!value) return "";
        if (value.length > 40) {
        return value.slice(0, 40) + "...";
      }
      return value;
    },
    },
  data() {
    return {
      pageTotal: 0,
      currNum: 1,
      noticeData: [],
      noticeDetail:false,
      noticeContent:""
    };
  },
  methods: {	   
    getNotice(e) {
      var _this = this;
	
      _this.$http
        .get("retire-school-manage/notice/getSchoolNotices", {
          params: {
            studentId: _this.$store.state.studentId,
            // studentId: '1',
            startIndex:  e.startIndex,
            endIndex: e.endIndex,
          },
        })
        .then(function(res) {
          if (res.data.status === 2000) {
            _this.pageTotal = res.data.data.cnt;
            _this.noticeData = res.data.data.schoolNoticeList;
          } else {
            // _this.$CustomMessageError(res.data.msg);
            console.error(res.data.msg);
          }
        });
    },
    handlePage(value) {
      this.currNum = value;
      var currTemp = value - 1;
      var star = currTemp * 10 + 1;
      var end = currTemp * 10 + 10;
      var formFormat = {
        studentId: this.$store.state.studentId,
        startIndex: star,
        endIndex: end,
      };
      this.getNotice(formFormat);
    },
    readNotice(val){ 
    this.noticeDetail = true;
    this.noticeContent = val.content;
    // 点击新闻将其变状态成已读
    var _this = this;
      _this.$http
        .post("retire-school-manage/notice/updateSchoolNotice",{
            id: val.id,
            readInd:'0'
        })
        .then(function(res) {
          if (res.data.status === 2000) { 
              // 更新消息数据
            _this.getNotice();
          } else {
            _this.$CustomMessageError(res.data.msg);
          }
        });
    }
  },
		
  created(){
	  let e = {
	   studentId: this.$store.state.studentId,
	   startIndex: 1,
	   endIndex: 10,
	  };
      this.getNotice(e);
	 
  }
 
  
};
</script>

<style lang="less" scoped>
@import '../../styles/base/_variables.less';

.mainBox {
  width: 1200px;
  margin: auto;
}

@media screen and (max-width: 768px) {
  .mainBox {
    height: calc(100vh - @mobile-header-footer-height);
    width: 100%;
    padding: 0 15px;
  }
  .list {
    padding: 12px 0 12px 35px;
  }
  .list .cont {
    font-size: 16px;
    width: 100%;
    margin-bottom: 8px;
  }
  .dateTime {
    font-size: 12px;
    float: left;
    margin-left: 35px;
  }
  .list .ide {
    top: 16px;
  }
  .noticeConM {
    padding: 15px;
    font-size: 14px !important;
    line-height: 24px;
  }
}

.list{padding:15px 0 15px 40px; border-bottom: 1px #ccc dashed; position: relative; }
.list .cont{ float: left; font-size:18px;}
.list .ide{ position:absolute; left:0; top:20px; border:1px solid #ccc;padding:1px; color: #ccc; font-style:normal; line-height:12px; font-size:11px;}
.dateTime{float:right; font-size:14px;}
.read{color: #333; cursor: pointer}
.unread{ color: #ccc; cursor: pointer;}
.noticeConM{ padding:25px; font-size:16px !important; line-height:26px}
.empty{padding-top: 100px; text-align: center; color:#ccc}
</style>
